export default "__VITE_ASSET__CQbZNyDm__"